export type SongType = {
  title: string;
  subTitle: string | null;
  slug: string;
  audio: string | null;
  lyrics: string;
}

export const songs: SongType[] = [
  {
    title: 'People Like Me',
    subTitle: 'for charlotte',
    slug: 'people-like-me',
    audio: null,
    lyrics: `
My God he said to take the stones
And stone the people like me
His only joke, my only hope
To cross the broken seas
It's sinking in, I smile again
'Cause I could never be
As holy as the holy ones
Who lay their hands on

People like you
People like me
Some of us change
But I'll stay the same
Like the ghosts in the water
Who welcome your name
People like me
People like you
It's a long way up
It's a long way down
I hope it's worth that view

My God he said he'd set you free
Free from people like me
So laugh again and stand within
A space for all to see
The fallen form from pages torn
'Cause I could never be
As holy as the holy ones
Who say a prayer for

People like you
People like me
Some of us change
But I'll stay the same
Till the ghosts in the water
Call out my name
People like me
People like you
It's a long way up
It's a long way down
It's such a pretty view   
`
  },
  {
    title: "Anthony's Dream",
    subTitle: null,
    slug: 'anthonys-dream',
    audio: "/audio/anthonys-dream.mp3",
    lyrics: `
Where are, where are the stars?

Lost in a world with no northern star

Shifting landscape a broken car

Where are, where are the stars?

Where are, where are...

...the stars have set sail for the distant sun

The journey is long and the night is young
`
  }
];